<template>
  <div>
    <!-- {{currentLessonIndex}} -->
      <!-- <pre> {{ myCourseList.classLesson }}</pre> -->
    <div class="cstm-wrapper" v-if="myCourseList">
      <div :class="{ activeNav: activeNav }" class="left-menu-sidebar">
        <!-- only for tab/mobile  -->
        <button
          @click="toggleNav"
          :class="{ rotate: activeNav }"
          class="hamburg-btn"
        >
          <feather-icon icon="ChevronRightIcon" />
        </button>

        <div class="course-cstm-heading">
          <feather-icon icon="FileTextIcon"/>
          <span class="ml-2">{{ myCourseList.name }}</span>
        </div>

        <!--SideNavbarMenuComponent -->
        <div class="menuNav">
          <!-- <p
            class="font-bold left-menu-name"
            :class="{ active: course }"
            @click="selectTab('course')"
          >
            Course Content
            <feather-icon icon="CheckCircleIcon"  v-if="myCourseList.courseComplete > 0" />
          </p>
          <vs-divider /> -->

          <template v-for="(subjectLessons, subject) in groupedList">
            <vs-collapse :key="subject">
              <vs-collapse-item>
                <div slot="header">
                  <h6>
                    {{ subject }}
                  </h6>
                </div>

                <div
                  v-for="(eachLesson, index) in myCourseList.classLesson"
                  :key="index"
                >
                  <template v-if="eachLesson.lesson_subjects[0].subject.subject_name === subject">
                    <p
                      class="font-bold left-menu-name"
                      :class="[lesson && activeLessonIndex === index ? 'active' : '']"
                      @click="selectTab('lesson', index)"
                    >
                      {{ eachLesson.name }}
                      <feather-icon icon="CheckCircleIcon" 
                      v-if="eachLesson.lesson_complete_count > 0"
                      />
                    </p>

                    <vs-collapse
                    :open="true"
                      class="cstm-menu-collapse"
                      v-if="eachLesson.lesson_topics.length"
                    >
                      <vs-collapse-item>
                        <div slot="header">
                          <h6>
                            <span class="mr-2">{{
                              eachLesson.lesson_topics.length
                            }}</span
                            >Topic
                          </h6>
                        </div>
                        <div
                          v-for="(eachTopic, topicIndex) in eachLesson.lesson_topics"
                          :key="topicIndex"
                        >
                          <p
                            class="font-bold left-menu-name my-1"
                            :class="[
                              topic && activeTopicIndex === topicIndex && activeLessonIndex === index ? 'active' : '',
                            ]"
                            @click="selectTab('topic', index, topicIndex)"
                          >
                            {{ eachTopic.topic.name }}
                            <feather-icon icon="CheckCircleIcon" 
                            v-if="eachTopic.topic.topic_complete_count > 0"
                            />
                          </p>
                        </div>
                      </vs-collapse-item>
                    </vs-collapse>
                    <vs-divider />
                  </template>
                </div>
              </vs-collapse-item>
            </vs-collapse>
          </template>
        </div>
        <!--SideNavbarMenuComponent -->
      </div>

      <div class="main-content">
        <!-- progress bar card  -->
        <vs-card>
          <div class="progress-bar-container" v-if="lessonLength">
            <div>
              <h6>Your Progress</h6>
              <vs-progress :height="8" :percent="calculatePercentage"></vs-progress>
              <p class="primary-txt ml-4 info">{{calculatePercentage}}% Complete</p>
              <p class="info">{{calculateComplete}}/{{lessonLength}} Lessons</p>
            </div>
            <div>
              <div class="status-badge" v-if="calculatePercentage !== 100">In Progress</div>
              <div class="status-badge" v-else>Completed</div>

            </div>
          </div>
          <div class="progress-bar-container" v-else>
            <div>
              <h6>Your Progress</h6>
              <vs-progress :height="8" :percent="calculatePercentageCourse"></vs-progress>
              <p class="primary-txt ml-4 info">{{calculatePercentageCourse}}% Complete</p>
              <!-- <p class="info">{{calculateComplete}}/{{lessonLength}} Lessons</p> -->
            </div>
            <div>
              <div class="status-badge" v-if="calculatePercentageCourse !== 100">In Progress</div>
              <div class="status-badge" v-else>Completes</div>

            </div>
          </div>
        </vs-card>

        <div class="main-inner-content">
          <!-- <pre>{{myCourseList}}</pre> -->
          <course-content
            v-if="course"
            :courseContent="myCourseList"
            @backToLesson="redirectToLesson"
            :platform_customer_id="platform_customer_id"
          />
          <!-- {{myCourseList.courseSetting.content_visibility}} -->
          <lessons
            v-if="lesson"
            :lessonContent="myCourseList"
            :lessonIndex="currentLessonIndex"
            :class_id="class_id"
            :platform_customer_id="platform_customer_id"
            @backToContent="redirectToContent"
            @backToLesson="redirectToLesson"
            @backToTopic="redirectToTopic"
            
          />
          <topics
            v-if="topic"
            :platform_customer_id="platform_customer_id"
            :lessonContent="myCourseList"
            :lessonIndex="currentLessonIndex"
            :TopicIndex="currentTopicIndex"
            @backToContent="redirectToContent"
            @backToLesson="redirectToLesson"
            @backToTopic="redirectToTopic"
          />
        </div>
        <!-- {{currentLessonIndex}}
        {{currentTopicIndex}} -->
      </div>
    </div>
  </div>
</template>

<script>
import CourseContent from './Components/CourseContent.vue'
import Lessons from './Components/Lessons.vue'
import Topics from './Components/Topics.vue'

import {getClassDetails} from '@/api/classes'
/* import { getCourseDetail } from '@/api/course/courseapi' */
import { percentageMixin } from './mixins/MarkCompleteMixin'

export default {
  name: 'OverallContent',
  components: {
    CourseContent,
    Lessons,
    Topics
  },
  props: {
    platform_customer_id:{},
  },
  mixins:[percentageMixin],
  data () {
    return {
      class_id: null,
      course: true,
      lesson: false,
      topic: false,
      content: false,
      files: false,
      activeNav: false,
      myCourseList: '',
      default_course_image: '',
      currentLessonIndex: '',
      currentTopicIndex: '',
      activeLessonIndex: undefined,
      activeTopicIndex: undefined,
      lessonLength:null,
      client_user_id: localStorage.getItem('userId'),
      groupedList: null
    }
  },
  created () {
    /* const client_user_id = this.$route.params.client_user_id
    const course_name = this.$route.params.course_name
    console.log(client_user_id)
    console.log(course_name) */
    //this.fetchFullCourse(client_user_id, course_name)
    this.fetchFullCourse()
  },
  methods: {
    checkingFreeForm (type, index, topicIndex) {

      if (type === 'lesson') {
        console.log(this.myCourseList.courseComplete)
        if (index === 0) {
          return !!this.myCourseList.courseComplete

        } else {
          const topicsLength = this.myCourseList.classLesson[index - 1].lesson_topics.length

          if (topicsLength) {
            return !!this.myCourseList.classLesson[index - 1].lesson_topics[topicsLength - 1].topic.topic_complete_count
          } else {
            return !!this.myCourseList.classLesson[index - 1].lesson_complete_count
          }
          
        }
      } else if (type === 'topic') {
        console.log(topicIndex)
        if (topicIndex === 0) {
          return !!this.myCourseList.classLesson[index].lesson_complete_count
        } else {
          return !!this.myCourseList.classLesson[index].lesson_topics[topicIndex - 1].topic.topic_complete_count

        }
      }
    },
    selectTab (type, index, topicIndex) {

      const checkingFreeForm = true
      //const checkingFreeForm = this.checkingFreeForm(type, index, topicIndex)
      console.log(checkingFreeForm)
      if (checkingFreeForm) {
        if (type === 'course') {
          this.course = true
          this.lesson = false
          this.topic = false
          this.content = false
          this.files = false
        } else if (type === 'lesson') {
          this.course = false
          this.lesson = true
          this.topic = false
          this.content = false
          this.files = false
          this.currentLessonIndex = index
          this.activeLessonIndex = index
        } else if (type === 'topic') {
          this.course = false
          this.lesson = false
          this.topic = true
          this.content = false
          this.files = false
          console.log(index)
          console.log(topicIndex)
          this.currentLessonIndex = index
          this.activeLessonIndex = index

          this.currentTopicIndex = topicIndex
          this.activeTopicIndex = topicIndex
        }
      } else {
        this.showSuccessMessage('Error', 'You Have to Complete Your Previous Content before proceeding', 'danger')
      }

     
    },
    toggleNav () {
      this.activeNav = !this.activeNav
    },
    async fetchFullCourse () {
      try {
        this.$vs.loading({
          text: 'Fetching Class Curriculum'
        })
        const payload = {
          customer_id:this.platform_customer_id
        }
        // const queryParams = this.$route.query || {}
        // this.query_page.page = queryParams.page || 1
        const responseClient = await getClassDetails(this.client_user_id, payload)
        
        console.log(responseClient)
        this.myCourseList = responseClient.data.data.class_details

        // eslint-disable-next-line no-undef
        this.groupedList = _.groupBy(this.myCourseList.classLesson, lesson => lesson.lesson_subjects[0].subject.subject_name)

        // console.log(responseClient)
        this.default_course_image =
          responseClient.data.data.class_default_image

        this.lessonLength = this.myCourseList.classLesson.length

        const type = this.$route.params.type 
        const lessonIndex = this.$route.params.lessonIndex 
        const topicIndex = this.$route.params.topicIndex 


        if (type) {
          this.selectTab(type, lessonIndex, topicIndex)
        }
        console.log(type)

        this.class_id = responseClient.data.data.class_details.class_id
        this.$emit('get_all_content', responseClient.data.data.class_details)

      } catch (error) {
        console.log(error)
        this.$vs.loading.close()
      } finally {
        this.$vs.loading.close()
      }
    },
    redirectToContent () {
      console.log('hooo')
      this.selectTab('course', null, null)
    },
    redirectToLesson (index) {
      console.log('hi')
      console.log(index)
      this.selectTab('lesson', index, null)
    },
    redirectToTopic (index, topicIndex = 0) {
      console.log('hi')
      console.log(index)
      console.log(topicIndex)
      this.selectTab('topic', index, topicIndex)
    }
  }
}
</script>

<style>
.left-menu-name .feather-icon {
  float: right;
  color: #28c76f;
}
.left-menu-name svg {
  width: 18px;
}
</style>